import moment from 'moment';

export const buildCreditExportRows = (transactions = []) => {
  const rows = [];
  let totalCredits = 0;

  (transactions || []).forEach((item) => {
    totalCredits += item.amount || 0;
    rows.push({
      type: item.credit_type || '-',
      booking_id: item.resolved_booking_id || '-',
      amount: item.amount || 0,
      balance_after: item.balance_after || 0,
      description: item.description || '-',
      datetime: item.created_at
        ? moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')
        : '-',
    });
  });

  rows.push({
    type: 'Total',
    amount: totalCredits,
  });

  return {
    rows,
    totalCredits,
  };
};
